import React from "react";
import { marqueeItems } from "../mock";
import { Star } from "lucide-react";

export default function Marquee() {
  const doubled = [
    ...marqueeItems.map((item, i) => ({ id: `m-a-${i}`, text: item })),
    ...marqueeItems.map((item, i) => ({ id: `m-b-${i}`, text: item })),
  ];
  return (
    <section aria-label="marquee" className="py-10 bg-brand overflow-hidden">
      <div className="marquee-track flex whitespace-nowrap gap-14 items-center">
        {doubled.map((item) => (
          <div key={item.id} className="flex items-center gap-6 text-white/95">
            <span className="font-display text-2xl md:text-4xl font-bold spaced-heading">{item.text}</span>
            <Star size={22} className="text-white/70" fill="currentColor" />
          </div>
        ))}
      </div>
    </section>
  );
}
